import React from 'react'
import { useState, useEffect, useContext, useMemo } from 'react';
import Select from 'react-select';

import cogoToast from "cogo-toast";
import { FaCheckCircle, FaExclamationCircle, FaPrint, FaSearch, FaTimesCircle, FaCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";

import { getList, postList, genericPost, genericGet } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, BASE_URL } from "../../../Constants";
import AppContext from "../../../AppContext";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms';
import { getListStaffDetailsRequestBody, getLoggedInStaffAccountId, normalizeLeaveDocuments, normalizeLeaveRecord } from '../../../services/Utils';
import LeaveDocumentList from "./LeaveDocumentList";


import "react-multi-date-picker-calendar/dist/calendar.css";

const parseLeaveDaysList = (daysRaw) => {
  if (Array.isArray(daysRaw)) return daysRaw;
  if (typeof daysRaw !== "string" || !daysRaw.trim()) return [];
  try {
    const parsed = JSON.parse(daysRaw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const PrintLeave = (props) => {
  const history = useHistory();

  const { data } = (props.location && props.location.state) || {};
  const leaveIdFromQuery = useMemo(() => {
    const params = new URLSearchParams(props.location?.search || window.location.search);
    return params.get("id");
  }, [props.location?.search]);

  const global = useContext(AppContext);

  const [IsLoading, setIsLoading] = useState(false)
  const [leave_reason, setLeave_reason] = useState("")
  const [selectedDates, setSelectedDates] = useState([]);
  const [leave_type, setLeave_type] = useState(null)
  const [leave_types, setLeave_types] = useState([]);
  const [staff_code, setstaff_code] = useState("")
  const [staff_data, setstaff_data] = useState(null)
  const [users, setUsers] = useState([])
  const [approvalComments, setapprovalComments] = useState("")
  const [supervisor, setSupervisor] = useState(null)
  const [hr_staff, setHr_staff] = useState(null)
  const [leaveData, setLeaveData] = useState(data || null)
  const canUpdateLeaveApprover = ability.can(PERMS.UPDATE, PERMS.CAN_UPDATE_LEAVE_APPROVER);

  const convert_date = (m) => {
    var date = new Date(m);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);

    let formatted = `${year}-${month}-${day}`;
    return formatted;
  }

  useEffect(() => {
    listLeaveTypes();
    const staffRequest = getListStaffDetailsRequestBody(global.get_logged_in_user());
    listUsers();
    if (staffRequest) {
      load_staff_details(staffRequest);
    }
  }, [])

  useEffect(() => {
    if (data) {
      setLeaveData(normalizeLeaveRecord(data));
      return;
    }
    if (!leaveIdFromQuery) return;

    setIsLoading(true);
    genericGet(`${ENDPOINTS.LEAVE_DETAILS}/${leaveIdFromQuery}`)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200 && res.data.status == SUCCESS_RESULT) {
          setLeaveData(normalizeLeaveRecord(res.data.data));
        } else {
          cogoToast.error(res.data?.message || "Failed to load leave details", {});
        }
      })
      .catch(() => {
        setIsLoading(false);
        cogoToast.error("Failed to load leave details", {});
      });
  }, [data, leaveIdFromQuery])

  const listUsers = async () => {
    setIsLoading(true);
    setUsers(await getList(ENDPOINTS.LIST_USERS))
    setIsLoading(false);
  }

  useEffect(() => {
    if (!leaveData || !users?.length) return;

    const supervisorId = leaveData?.supervisor_id || leaveData?.supervisor?.id;
    const hrId = leaveData?.hr_id || leaveData?.hr?.id;

    const supervisorOption = users.find((u) => u.value === supervisorId);
    const hrOption = users.find((u) => u.value === hrId);

    if (supervisorOption) {
      setSupervisor({ value: supervisorOption.value, label: supervisorOption.text });
    }
    if (hrOption) {
      setHr_staff({ value: hrOption.value, label: hrOption.text });
    }
  }, [leaveData, users]);

  const handleUpdateApprover = () => {
    if (!leaveData?.id) {
      cogoToast.error("Leave ID is missing", {});
      return;
    }

    const payload = {
      leave_id: leaveData.id,
      supervisor_id: (leaveData?.supervisor_approval == 10000 ? supervisor?.value : leaveData?.supervisor_id) || leaveData?.supervisor?.id || "",
      hr_id: (leaveData?.hr_approval == 10000 ? hr_staff?.value : leaveData?.hr_id) || leaveData?.hr?.id || "",
    };

    if (!payload.supervisor_id || !payload.hr_id) {
      cogoToast.error("Please select both Supervisor and HR approvers", {});
      return;
    }

    setIsLoading(true);
    genericPost(ENDPOINTS.UPDATE_LEAVE_APPROVER, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.status == 200 && response.data.status == SUCCESS_RESULT) {
          cogoToast.success(response.data.message || "Approvers updated successfully", {});
          setLeaveData((prev) => ({
            ...prev,
            supervisor_id: payload.supervisor_id,
            hr_id: payload.hr_id,
            supervisor: {
              ...(prev?.supervisor || {}),
              id: payload.supervisor_id,
              name: supervisor?.label || prev?.supervisor?.name,
            },
            hr: {
              ...(prev?.hr || {}),
              id: payload.hr_id,
              name: hr_staff?.label || prev?.hr?.name,
            },
          }));
        } else {
          cogoToast.error(response?.data?.message || "Failed to update approvers", {});
        }
      })
      .catch((err) => {
        setIsLoading(false);
        cogoToast.error("Something went wrong, please try again.", {});
      });
  };
  const approveLeave = async (data) => {
    console.log(data)
    genericPost(ENDPOINTS.APPROVE_LEAVE, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
            cogoToast.success(response.data.message, {
              hideAfter: 5,
            });
            history.push({
              pathname: "/hrm/leave/pending-actions",

            });
          } else {
            cogoToast.error(response.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
        });
      });
  }

  const load_staff_details = (requestBody) => {
    if (!requestBody || (!requestBody.staff_code && !requestBody.staff_id)) {
      return;
    }

    setIsLoading(true);
    genericPost(ENDPOINTS.LIST_STAFF_DETAILS, requestBody)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            setstaff_data(res.data["data"]);

          } else {
            cogoToast.error(res.data.message, {});
          }
        } else {
          cogoToast.error("Connection error. Please try again.", {});
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        cogoToast.error("Critical error occurred. Please try again.", {});
      });
  };

  const find_staff_by_code = (staff_id) => {
    if (!staff_id) {
      return;
    }

    load_staff_details({ staff_code: String(staff_id).trim() });
  };

  const createLeave = (e) => {
    e?.preventDefault();

    if (selectedDates.length < 1) {
      cogoToast.error("Please select at lease One Day");
      return;
    }
    if (!leave_type?.id) {
      cogoToast.error("Please select leave type");
      return;
    }
    let formatted_dates = [];
    selectedDates.forEach((d) => {
      formatted_dates.push(convert_date(d));
    })

    let data = {


      "staff_id": getLoggedInStaffAccountId(global.get_logged_in_user()),

      "leave_type_id": leave_type?.id,
      "total_days": formatted_dates.length,
      "days": formatted_dates,
      "leave_reason": leave_reason,
      "supervisor_id": supervisor.value,
      "hr_id": hr_staff.value


    }

    console.log(data)


    genericPost(ENDPOINTS.CREATE_LEAVE, data)
      .then((res) => {

        setIsLoading(false);
        if (res.status == 200) {

          let responseData = res.data;
          if (res.data.status == SUCCESS_RESULT) {
            global.show_operation_result({ success: true, msg: "Leave Form submitted Successfully" })

            cogoToast.success(responseData.message);


          }
          else {
            cogoToast.error(responseData.message);
          }
        } else {
          cogoToast.error(res.data.message, {});
        }

      })
      .catch((err) => {
        setIsLoading(false);
        cogoToast.error(err.toString(), {});

        console.log(err);
      });

  }
  const listLeaveTypes = async () => {
    setIsLoading(true);
    setLeave_types(await getList(ENDPOINTS.LEAVE_TYPES));
    setIsLoading(false);
  }



  const PrintLeave = () => {



    var printContents = document.getElementById("print");

    let w = 600;
    let h = 700;

    var left = window.screen.width / 2 - w / 2;
    var top = window.screen.height / 2 - h / 2;
    var docprint = window.open(
      "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
      w +
      ", height=" +
      h +
      ", top=" +
      top +
      ", left=" +
      left
    );

    docprint.document.open();
    docprint.document.write(`<head><style>
  table{
    border-collapse:collapse !important;
  }
  table {
    width: 95% !important;
    margin: auto !important;
  }
   
   td {
    border: 1px solid rgba(200, 198, 198, 0.452);
    text-align: left;
    border: 1px solid gray;
    padding: 5px !important;
    color: #000000 !important;
  }</style></head>   `);

    docprint.document.write(printContents.innerHTML);




    setTimeout(() => {

      docprint.print();
    }, 700);
    setTimeout(() => {

      docprint.close();
    }, 900);

    return;



    //window.print("a4_invoice");
  };

  const getMinDate = () => {
    try {
      var date = new Date();




      return date.setDate(date.getDate() - 1);
    } catch (e) { alert(e) }
    //.addDays(-1);

  }

  const handleDateChange = (dates) => {


    setSelectedDates(dates);
  };
  return (
    <div className="page-wrapper " style={{ width: "95%", margin: "auto" }}>




      <div className="page-body ">
        <div className="container-xl">
          <div className="card">


            <div className="card-header">

              <button onClick={() => PrintLeave()} className='btn btn-primary'><FaPrint> </FaPrint> &nbsp;&nbsp; Print </button>
            </div>



            <div className="card-body" id="print">
              <center>

                <img
                  src="/images/logo.jpg"
                  id="icon"
                />
                <h1> ISLAMIC RELIEF SOMALIA</h1>
                <hr />
                <h1> LEAVE FORM </h1>

              </center>
              {/* <div className="input-group">

                                <input type="text"   styles={{width:"200px"}} onChange={(e)=>setstaff_code(e.target.value)} className="form-control" placeholder='SOM XXXX'/>
                                
                              </div> */}

              <hr />
              <div className="table-responsive">
                <table className="info_table table" >


                  <tr>
                    <td className="blue-bg">STAFF ID</td> <td>{leaveData?.staff_id} </td>
                    <td className="blue-bg">Staff Name </td> <td> {leaveData?.created_by?.name}</td>

                  </tr>
                  <tr>
                    <td className="blue-bg">Email Address</td> <td> {leaveData?.staff?.email}</td>
                    <td className="blue-bg"> Request Date </td>  <td>{leaveData?.request_date} </td>

                  </tr>
                  <tr>
                    <td className="blue-bg">Leave Type </td> <td> {leaveData?.leave_type?.name}</td>
                    <td className="blue-bg">Number of Days </td> <td> {leaveData?.total_days}</td>
                  </tr>
                  <tr>
                    {/* <td className="blue-bg">Leave Days </td> <td> {JSON.parse(data?.days).map((d) => {
                      return <li>{d}</li>;
                    })}</td> */}
                    <td className="blue-bg">
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Leave Days</div>
                          <div style={{ fontSize: '12px', marginTop: '8px' }}>Balance before: {leaveData?.balance_before}</div> 
                          <div style={{ fontSize: '12px', marginTop: '4px' }}>Balance after: {leaveData?.balance_after}</div> 
                        </div>
                      </td>

                        <td >
                          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            {
                              // Split the days array into chunks of 7
                              (() => {
                                const days = parseLeaveDaysList(leaveData?.days);
                                if (!days.length) {
                                  return <span>N/A</span>;
                                }
                                const columns = [];

                                for (let i = 0; i < days.length; i += 3) {
                                  columns.push(days.slice(i, i + 3));
                                }

                                return columns.map((col, colIndex) => (
                                  <div key={colIndex} style={{ flex: 1 }}>
                                    {col.map((d, rowIndex) => (
                                      <div key={rowIndex} style={{ marginBottom: '4px' }}>
                                        <strong><FaCircle style={{fontSize: '10px', marginRight: '4px', marginLeft: '4px'}}></FaCircle></strong>{d}
                                      </div>
                                    ))}
                                  </div>
                                ));
                              })()
                            }
                          </div>
                        </td>

                    
                    <td className="blue-bg">Leave Reason </td> <td> {leaveData?.leave_reason}</td>
                  </tr>

                  <tr>

                    <td>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    
                      <div style={{ fontSize: '13px', marginTop: '4px' }}>Handover note delegated? <strong>YES </strong><br /></div>
                       <div style={{ fontSize: '13px', marginTop: '4px' }}>Handover note delegated to :<br />  <strong>{leaveData?.handedover_to?.name}</strong></div>
                        </div>
                    </td>

                    <td colSpan={3}>
                      Leave Documents : <br />
                      <LeaveDocumentList
                        documents={normalizeLeaveDocuments(leaveData)}
                        emptyText="No documents uploaded."
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="blue-bg">Supervisor Name</td>
                    <td>
                      {leaveData?.supervisor_approval == 10000 && canUpdateLeaveApprover ? (
                        <Select
                          value={supervisor}
                          onChange={setSupervisor}
                          options={users?.map((u) => ({ value: u.value, label: u.text }))}
                          placeholder="Select Supervisor"
                        />
                      ) : (
                        leaveData?.supervisor?.name
                      )}
                    </td>
                    <td className="blue-bg">HR Staff Name</td>
                    <td>
                      {leaveData?.hr_approval == 10000 && canUpdateLeaveApprover ? (
                        <Select
                          value={hr_staff}
                          onChange={setHr_staff}
                          options={users?.map((u) => ({ value: u.value, label: u.text }))}
                          placeholder="Select HR Staff"
                        />
                      ) : (
                        leaveData?.hr?.name
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="blue-bg">Supervisor Approval  </td> <td>
                    <div style={{ fontSize: '13px', marginTop: '4px' }}>
                      {leaveData?.supervisor_approval == 10000 ? <span><FaExclamationCircle style={{ color: "grey" }}>

                      </FaExclamationCircle> &nbsp;Pending  </span> : leaveData?.supervisor_approval == 10002 ? <span><FaTimesCircle style={{ color: "red" }}>

                      </FaTimesCircle> &nbsp; Rejected </span> : <div> <FaCheckCircle style={{ color: "green" }}></FaCheckCircle>
                        &nbsp; @ {leaveData?.supervisor_approval_date} </div>}</div>

                    </td>
                    <td className="blue-bg">HR Approval  </td> <td>
                    <div style={{ fontSize: '13px', marginTop: '4px' }}>
                      {leaveData?.hr_approval == 10000 ? <span><FaExclamationCircle style={{ color: "grey" }}>

                      </FaExclamationCircle> &nbsp;Pending  </span> : leaveData?.hr_approval == 10002 ? <span><FaTimesCircle style={{ color: "red" }}>

                      </FaTimesCircle> &nbsp; Rejected </span> : <div> <FaCheckCircle style={{ color: "green" }}></FaCheckCircle>
                        &nbsp; @ {leaveData?.hr_approval_date} </div>} </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <div style={{ fontSize: '14px', fontWeight: 'bold' }}> SuperVisor Comment </div>
                    </td>
                    <td>
                      {leaveData?.supervisor_comments}
                    </td>

                    <td>
                    <div style={{ fontSize: '14px', fontWeight: 'bold' }}> HR Comment </div>
                    </td>
                    <td>
                      {leaveData?.hr_comments}
                    </td>
                  </tr>
                  {canUpdateLeaveApprover && (leaveData?.supervisor_approval == 10000 || leaveData?.hr_approval == 10000) && (
                    <tr>
                      <td colSpan={4} style={{ textAlign: "right" }}>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={handleUpdateApprover}
                          disabled={IsLoading}
                        >
                          Update Pending Approvers
                        </button>
                      </td>
                    </tr>
                  )}

                </table>
              </div>



            </div>

{/* 
            {JSON.stringify(data)} */}


          </div>
        </div>
      </div>
    </div>


  )
}

export default PrintLeave